import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Building2, Users, MessageCircle, LucideIcon } from 'lucide-react';

export interface AdminNavItem {
  to: string;
  icon: LucideIcon;
  label: string;
}

export const getAdminNavItems = (): AdminNavItem[] => [
  {
    to: '/admin',
    icon: LayoutDashboard,
    label: 'Dashboard'
  },
  {
    to: '/admin/bofellesskap',
    icon: Building2,
    label: 'Bofellesskap'
  },
  {
    to: '/admin/brukere',
    icon: Users,
    label: 'Brukere'
  },
  {
    to: '/admin/meldinger',
    icon: MessageCircle,
    label: 'Meldinger'
  }
];

export function AdminSidebar() {
  const mainNavigation = getAdminNavItems();
  
  return (
    <nav className="hidden lg:flex w-48 2xl:w-64 shadow-lg flex-col z-30 bg-base-white fixed top-16 left-0 bottom-0 border-r border-gray-200">
      <div className="absolute inset-0 bg-base-white -z-10" />
      
      <div className="flex flex-col h-full">
        <div className="flex-1 p-4 xl:p-4 2xl:p-6 pt-6 overflow-y-auto">
          <div className="space-y-2">
            {mainNavigation.map(({ to, icon: Icon, label }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) => `
                  w-full flex items-center gap-3 px-3 xl:px-3 2xl:px-4 py-3 rounded-lg transition-all duration-200
                  ${isActive 
                    ? 'bg-condo-light text-condo-dark shadow-sm border border-condo-med/20' 
                    : 'hover:bg-light-1 text-gray-700 hover:text-condo-dark hover:shadow-sm'
                  }
                `}
              >
                {({ isActive }) => (
                  <>
                    <Icon className={`h-[18px] w-[18px] ${isActive ? 'text-condo-dark' : 'text-gray-600'}`} />
                    <span className="text-sm font-medium">{label}</span>
                  </>
                )}
              </NavLink>
            ))}
          </div>
        </div>

        {/* Header med logo/tittel - limt til bunnen */}
        <div className="sticky bottom-0 bg-base-white px-6 py-4 border-t border-gray-200 mt-auto">
          <h2 className="text-lg font-semibold text-condo-dark">Admin Panel</h2>
        </div>
      </div>
    </nav>
  );
}